import { IUser } from '@Data/users/Interfaces';

export interface IAdminState {
    isUserSuperAdmin: boolean;
    superAdministrators: IUser[];
}

export const initialAdminState: IAdminState = {
    isUserSuperAdmin: false,
    superAdministrators: [],
};
